import vandamme_win from "url:/src/img/vandamme_win.png";
import vandamme_loose from "url:/src/img/vandamme_loose.png";
import scoreSFXURL from "url:/src/sounds/coin.wav";
import { gsap } from "gsap";
let scoreSent = false;

const trad = {
  fr: {
    h3_win: "Bien joué l'artiste !",
    p_win: "Tu nous as impressionné. Bonnes fêtes de fin d'année 🎅",
    h3_loose: "Pas mal, mais Internet Explorer t'as vaincu ! Bonnes fêtes de fin d’année 🎅",
    damage: "Dégats",
    time: "Temps",
    total: "Score total",
    send: "Partage ton score !",
    tryagain: "Recommencer"
  }
}

export default function ({ win, score, time }) {
  const lang = document.getElementById("game").getAttribute("data-lang");
  const c = trad[lang];

  let fscore = score;
  if (win) {
    let tratio = 1 - (time / (3 * 60 + 27));
    fscore += Math.floor(tratio * 5000);
  }

  let result = {
    win: win,
    score: fscore,
    time: formatTime(time),
  }
  const base64 = encodeURI(btoa(JSON.stringify(result)));
  const contact_url = document.getElementById("game").getAttribute("data-contact") + "?game=" + base64;

  const gameover = document.createElement("div");
  gameover.classList.add("gameover");
  if (!win) gameover.classList.add("gameover--lose");

  gameover.innerHTML =
    `<div class="gameover__header">
        <h3 class="${win ? 'win' : 'lose'}">${win ? c.h3_win : c.h3_loose}</h3>
        <div class="gameover__header__line"></div>
        ${win ? `<p>${win ? c.p_win : c.p_loose}</p>` : ""}
        <img src="${win ? vandamme_win : vandamme_loose}">
    </div>
    <div class="scoreboard">
        <div class="scoreboard__score">
            <span>${c.damage}</span><span>${score}</span>
        </div>
        <div class="scoreboard__score scoreboard__score--time">
            <span>${c.time}</span><span>${formatTime(time)}</span>
        </div>
        <div class="scoreboard__score">
            <span>${c.total}</span><span>${fscore}</span>
        </div>
        <button class="scoreboard__send" id="open-share-modal-btn" href="${contact_url}">${c.send}</button>
        <button id="scoreboard__tryagain" class="scoreboard__tryagain">${c.tryagain}</button>
    </div>`;

  document.getElementById("game").append(gameover);

  scoreSent = false;

  const openShareModalBtn = document.getElementById("open-share-modal-btn");
  if (openShareModalBtn) openShareModalBtn.addEventListener('click', () => toggleShareModal(score, formatTime(time), fscore));

  const shareModalOverlay = document.getElementById("share-modal-overlay");
  if (shareModalOverlay) shareModalOverlay.addEventListener('click', () => toggleShareModal(score, formatTime(time), fscore));

  const shareModalCloseBtn = document.getElementById("share-modal-close-btn");
  if (shareModalCloseBtn) shareModalCloseBtn.addEventListener('click', () => toggleShareModal(score, formatTime(time), fscore));

  const shareBtn = document.getElementById("share-btn");
  if (shareBtn) shareBtn.addEventListener('click', () => sendScoreToDB(score, time, fscore, win));

  const tl = gsap.timeline();
  tl.delay(win ? 3 : 1);
  tl.from(".gameover__header img", { duration: .3, opacity: 0, scale: 0.8 });
  tl.from(".gameover__header h3, .gameover__header .gameover__header__line, .gameover__header p", { duration: .3, y: 20, opacity: 0 });
  tl.from(".scoreboard__score", {
    delay: 0.5, duration: .3, opacity: 0, scale: 0.8, stagger: {
      each: 0.5,
      onStart: playsound
    }, ease: "back.out(1.7)"
  });
  tl.from(".scoreboard__send, .scoreboard__tryagain", { delay: 0.5, duration: 1.5, opacity: 0 });

  document.getElementById("scoreboard__tryagain").onclick = function () {
    document.location.reload();
  }
}

function playsound() {
  const sfx = new Audio(scoreSFXURL);
  sfx.volume = 0.1;
  sfx.play();
}

function formatTime(time) {
  let min = Math.floor(time / 60);
  let sec = Math.floor(time % 60);
  if (sec < 10) sec = "0" + sec;
  return min + ":" + sec;
}

function validerEmail(email) {
  const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
  return regex.test(email);
}

function toggleShareModal(damage = 0, time = 0, total = 0) {
  const shareModalWrapper = document.getElementById("share-modal-wrapper");

  shareModalWrapper.style.display = shareModalWrapper.style.display === "flex" ? "none" : "flex";

  shareModalWrapper.querySelector("#damage-stats-value").textContent = damage;
  shareModalWrapper.querySelector("#time-stats-value").textContent = time;
  shareModalWrapper.querySelector("#total-stats-value").textContent = total;
}

async function encryptData(data) {
  const publicKeyPem = `
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAzm4OpnNRD+XJtdVWjiiN
qoWBaEVjswpCLnao9CPjzMubHJuiMzekjJjEWk0cY+EkvQnUY1NZjqv8cIlwwXx8
Mp8ruPprEQNuHRCXXn3tvWvnf74WZj5wHwWv9Pktuh6G99Emm79jVnrlIj0Rh/Oc
V/FrMt2njgCIHDXII779HBPBGt6+iUipTlYjroib34ETC+vO0QQH+IMvzEYUrs7K
v+WS+KqbJvxllt+fl3/Nn43JFQTnFO7Xs7OUzO/NYsV4flN0rND8ZZyHQx2WV3/v
jvhnZaGTGVQS93g3lXL5gBXvKtVz08mBHhEmd5ob1yafgYUVO+0UCQcbBaHc4JA3
vwIDAQAB  
`;

  const publicKey = await window.crypto.subtle.importKey(
    "spki",
    pemToArrayBuffer(publicKeyPem),
    { name: "RSA-OAEP", hash: "SHA-256" },
    false,
    ["encrypt"]
  );

  const encoded = new TextEncoder().encode(JSON.stringify(data));

  const encrypted = await window.crypto.subtle.encrypt(
    { name: "RSA-OAEP" },
    publicKey,
    encoded
  );

  return btoa(String.fromCharCode(...new Uint8Array(encrypted)));
}

function pemToArrayBuffer(pem) {
  const b64 = pem.replace(/-----(BEGIN|END) PUBLIC KEY-----/g, '').trim();
  const binary = atob(b64);
  const array = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) array[i] = binary.charCodeAt(i);
  return array.buffer;
}

async function sendScoreToDB(damage, time, score, win) {
  if (scoreSent) return;
  const shareModalMessage = document.getElementById('share-modal-message');
  const username = document.getElementById('usernameInput').value;
  const email = document.getElementById('emailInput').value;

  shareModalMessage.textContent = '';
  shareModalMessage.classList.remove('error');
  shareModalMessage.classList.remove('success');

  if (!username.trim()) {
    shareModalMessage.textContent = 'Nom requis';
    shareModalMessage.classList.add('error');
    return;
  }
  if (!email.trim()) {
    shareModalMessage.textContent = 'Email requis';
    shareModalMessage.classList.add('error');
    return;
  };
  if (!validerEmail(email)) {
    shareModalMessage.textContent = 'Email invalide';
    shareModalMessage.classList.add('error');
    return;
  }

  const payload = { username, email, score, time, damage, win, ts: Date.now() };
  const encryptedPayload = await encryptData(payload);

  //const response = await fetch("http://creano.paris/xxxx/addScore", {
  const response = await fetch("/api/addScore", {
    method: "POST",
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ data: encryptedPayload })
  })

  if (!response.ok) {
    const data = await response.json();
    if (data.error) {
      shareModalMessage.textContent = data.error;
      shareModalMessage.classList.add('error');
    }
    return;
  }

  scoreSent = true;

  const data = await response.json();
  if (data.message) {
    shareModalMessage.textContent = data.message;
    shareModalMessage.classList.add('success');
  }

  setTimeout(() => {
    document.getElementById('usernameInput').value = "";
    document.getElementById('emailInput').value = "";

    toggleShareModal();
  }, 1000);
}